import { changeLanguage } from "i18next"
import { lazy, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Route, BrowserRouter as Router, Routes } from "react-router-dom"

import Wrapper from "../components/auth/wrapper"
import BankDrawer from "../components/banks/create/drawer"
import CampaignDrawer from "../components/campaigns/create/drawer"
import CorporateDrawer from "../components/corporates/create/drawer"
import LoggedStructure from "../components/logged-structure"
import UserDrawer from "../components/user/create/drawer"
import { AppDispatch, RootState } from "../store"
import { getUserAllBanks } from "../store/actions/bank"
import ChangePassword from "../views/Auth/change-password"
import ForgotPassword from "../views/Auth/forgot-password"
import LoginAuth from "../views/Auth/login-auth"
import Otp from "../views/Auth/otp"
import BanksListView from "../views/Banks/List"
import CampaignsListView from "../views/Campaigns/List"
import CorporatesListView from "../views/Corporates/List"
import DistinteList from "../views/Distinte/List"
import Upload from "../views/Distinte/upload"
import FAQView from "../views/Faq"
import HomePage from "../views/home"
import PlicksList from "../views/Plicks/List"
import ReportView from "../views/Report/index"
// import UsersListView from '../views/Users/List';
import OtpProtectedRoute from "./otp-protected-route"
import ProtectedRoute from "./protected-route"

const UsersListView = lazy(() => import("../views/Users/List"))
// Definisci un array di rotte
const routes = [
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<HomePage />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/:theme",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<HomePage />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/banks",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<BanksListView />
					<BankDrawer />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/corporate",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<CorporatesListView />
					<CorporateDrawer />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/campaigns",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<CampaignsListView />
					<CampaignDrawer />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/distinte",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<DistinteList />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/distinta/:fileId",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<PlicksList />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/dashboard",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<HomePage />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/faq",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={false}>
					<FAQView />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/login",
		element: (
			<OtpProtectedRoute>
				<Wrapper>
					<LoginAuth />
				</Wrapper>
			</OtpProtectedRoute>
		),
	},
	{
		path: "/password-dimenticata",
		element: (
			<Wrapper>
				<ForgotPassword />
			</Wrapper>
		),
	},
	{
		path: "/change-password",
		element: (
			<Wrapper>
				<ChangePassword />
			</Wrapper>
		),
	},
	{
		path: "/otp",
		element: (
			<Wrapper>
				<Otp />
			</Wrapper>
		),
	},
	{
		path: "/report",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<ReportView />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/upload",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<Upload />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/upload/:fileId",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<Upload />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},
	{
		path: "/users",
		element: (
			<ProtectedRoute>
				<LoggedStructure isNeededBank={true}>
					<UsersListView />
					<UserDrawer />
				</LoggedStructure>
			</ProtectedRoute>
		),
	},

	/* {
        path: '/about',
        element: <AboutPage />,
        children: [
            {
                path: ':number',
                element: <AboutPage />
            },
            {
                path: '/about/pippo',
                element: <LayoutComponent />
            }
        ]
    },
    {
        path: '/layout',
        element: <LayoutComponent />,
        children: [
            {
                path: ':number',
                element: <AboutPage />
            }
        ]
    }*/
]

const RoutesList = () => {
	const dispatch = useDispatch<AppDispatch>()
	const isAuthenticate: boolean = useSelector(
		(state: RootState) => state.auth?.isAuthenticate
	)
	const isResetPassword: boolean = useSelector((state: RootState) =>
		!state.auth.user?.userPasswordReset == null ? true : false
	)
	const banksUserList: any = useSelector(
		(state: RootState) => state.banksUser?.list
	)

	const banksUserLoading: any = useSelector(
		(state: RootState) => state.banksUser.loading
	)

	useEffect(() => {
		/* i18next prepare to change language maybe set in localstorage, when change update
		 */
		const langAbbr: string = (window.localStorage.i18nextLng.split("-")[0] ||
			window.navigator.language.split("-")[0]) as string
		void changeLanguage(langAbbr)
	}, [])

	useEffect(() => {
		if (isAuthenticate && !isResetPassword && banksUserList.length == 0)
			dispatch(getUserAllBanks({ filter: null, sort: null }))
	}, [isAuthenticate, isResetPassword, banksUserList])

	return banksUserLoading ? null : (
		<Router>
			<Routes>
				{/* Utilizza map per creare le rotte dal tuo array */}
				{routes.map((route, index) => (
					<Route key={index} path={route.path} element={route.element}>
						{/* Rotte annidate (se presenti) */}
						{route.children &&
							route.children.map((childRoute, childIndex) => (
								<Route
									key={childIndex}
									path={childRoute.path}
									element={childRoute.element}
								/>
							))}
					</Route>
				))}
			</Routes>
		</Router>
	)
}

export default RoutesList
